<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="CorrectionRequestForm" @submit="addCorrectionRequest" :validation-schema="validationCorrectionSchema">
        <div class="row">
          <div class="col-12 mb-3">
            <h6 class="text-primary fw-semibold border-bottom pb-2">
              <i class="ri-information-line"></i> Informations générales
            </h6>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date et heure d’émission de la demande. <span class="text-danger">*</span>
              </label>
              <Field name="requested_at" type="date" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrez le date " />
              <ErrorMessage name="requested_at" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date limite souhaitée pour la prise en compte de la correction. <span class="text-danger">*</span>
              </label>
              <Field name="due_date" type="date" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrez le date " />
              <ErrorMessage name="due_date" class="text-danger" />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
               Représentation structurée <span class="text-danger">*</span>
              </label>
              <Field name="fields_concerned" as="textarea" class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="fields_concerned" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Status<span class="text-danger">*</span>
              </label>
              <Field name="status" v-slot="{ field }">
                <Multiselect :options="statusOptions" :searchable="true" multiple="false" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner le status" />
              </Field>
              <ErrorMessage name="status" class="text-danger" />
            </div>
          </div>

          <!-- <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                 <span class="text-danger">*</span>
              </label>
              <Field name="fields_concerned" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrez les champs concrnés par la correction" />
              <ErrorMessage name="fields_concerned" class="text-danger" />
            </div>
          </div> -->
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Message explicatif adressé au demandeur <span class="text-danger">*</span>
              </label>
              <Field name="message_to_requester" as="textarea" class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="message_to_requester" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date et heure de la réponse <span class="text-danger">*</span>
              </label>
              <Field name="responded_at" type="date" class="form-control shadow-none fs-md-15 text-black"
                placeholder="" />
              <ErrorMessage name="responded_at" class="text-danger" />
            </div>
          </div>


          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Référence vers la tâche de validation à l’origine de la demande <span class="text-danger">*</span>
              </label>
              <Field name="validationtasks" v-slot="{ field }">
                <Multiselect :options="validationtaskOptions" :searchable="true" multiple="false" track-by="label"
                  label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner la validation Tasks" />
              </Field>
              <ErrorMessage name="validationtasks" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Référence vers le dossier BESC <span class="text-danger">*</span>
              </label>
              <Field name="besc" v-slot="{ field }">
                <Multiselect :options="bescOptions" :searchable="true" multiple="false" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner le besc concerné " />
              </Field>
              <ErrorMessage name="besc" class="text-danger" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Référence vers l’utilisateur ayant émis la demande de correction <span class="text-danger">*</span>
              </label>
              <Field name="user" v-slot="{ field }">
                <Multiselect :options="acteurOptions" :searchable="true" multiple="false" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner l'utilisateur " />
              </Field>
              <ErrorMessage name="user" class="text-danger" />
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex align-items-center ">
              <button
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit">
                Valider
              </button>
              <router-link to="/listecorrectionrequests" class=" btn btn-danger transition border-0 lh-1 fw-medium"><i
                  class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>

  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '../../services/ApiService';
import * as Yup from 'yup';
import { error, success, hideModal } from '../../utils/utils';
import { TypeFretPaiement } from '@/models/TypeFretPaiement';
import { Modal } from 'bootstrap';
import Multiselect from '@vueform/multiselect'
import { CorrectionRequest } from '@/models/CorrectionRequest';
import router from '@/router';
import JwtService from '@/services/JwtService';

export default defineComponent({
  name: "AddModalCorrectionRequest",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect

  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }) {
    const validationCorrectionSchema = Yup.object().shape({
      requested_at: Yup.string().required('Ce champ est obligatoire'),
      due_date: Yup.string().required('Ce champ est obligatoire'),
      validationtasks: Yup.string().required('Ce champ est obligatoire'),
      // response_message: Yup.string().required('Ce champ est obligatoire'),
      status: Yup.string().required('Ce champ est obligatoire'),
      fields_concerned: Yup.string().required('Ce champ est obligatoire'),
      responded_at: Yup.string().required('Ce champ est obligatoire'),
      message_to_requester: Yup.string().required('Ce champ est obligatoire'),
      user: Yup.string().required('Ce champ est obligatoire'),
    });

    const CorrectionRequestForm = ref<CorrectionRequest | null>(null);
    const addModalCorrectionRequestRef = ref<null | HTMLElement>(null);
    const localItem = ref(props.item);
    const isUPDATE = ref(false);
    const validationtaskOptions = ref([])
    const bescOptions = ref([])
    const acteurOptions = ref([])
    const statusOptions = [
      { value: 'Ouvert', label: 'Ouvert' },
      { value: 'Traité', label: 'Traité' },
      { value: 'Annulée', label: 'Annulée' },
      { value: 'Expiré', label: 'Expiré' },


    ]

     const fetchValidationTask = async () => {
      try {
        const user = JwtService.getUser();
        console.log("user:", user);
        if (!user) return error("Utilisateur non connecté");
        const userId = user.userId.replace(/\/+$/, '').trim();
        if (!userId) return error("Utilisateur non connecté");
        const response = await ApiService.get(`/validationts?limit=0&userCreationId=${userId}`);
        const validationTaskData = response.data.data.data;
        validationtaskOptions.value = validationTaskData.map((validationtask) => ({
          value: validationtask.id,
          label: `${validationtask.status}`
        }))
      } catch (error) {
        //
      }
    }
    const fetchUser = async () => {
      try {
        const response = await ApiService.get('/users?limit=0');
        const acteurData = response.data.data.data;
        acteurOptions.value = acteurData.map((user) => ({
          value: user.id,
          label: `${user.nom} ${user.prenom}`
        }))
      } catch (error) {
        //
      }
    }

    const fetchBesc = async () => {
      try {
        const response = await ApiService.get('/bescs?limit=0');
        const bescData = response.data.data.data;
        bescOptions.value = bescData.map((besc) => ({
          value: besc.id,
          label: `${besc.refbesc}`
        }))
      } catch (error) {
        //
      }
    }

    const isDateField = (key: string) => {
      return [
        "requested_at",
        "due_date",
        "responded_at"
      ].includes(key);
    };

    const formatDate = (dateString: string) => {
      if (!dateString) return "";
      return dateString.split("T")[0];
    };


    const addCorrectionRequest = async (values: any, { resetForm }: any) => {
      values = values as CorrectionRequest;
      const token = localStorage.getItem('id_token');
      if (!token) {
        console.log("Aucun token trouvé dans le localStorage");
        return error("Utilisateur non connecté");
      }
      console.log("Token envoyé au backend:", token);
      console.log("Valeurs envoyées:", values);
      delete values.userId;
      ApiService.post("/correction", values)
        .then(({ data }) => {
          if (data.code == 201) {
            success(data.message);
            resetForm();
            router.push({ name: "ListeCorrectionRequestPage" })
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

    onMounted(() => {
      fetchValidationTask();
      fetchUser();
      fetchBesc();
    })

    return {
      CorrectionRequestForm,
      addModalCorrectionRequestRef,
      addCorrectionRequest,
      validationCorrectionSchema,
      // resetValue,
      validationtaskOptions,
      acteurOptions,
      bescOptions,
      statusOptions


    };
  },
});
</script>